/**
 * Client-side bot/crawler detection for Mixpanel.
 * Meta link-preview crawlers inflate Visit_Content; skip all Mixpanel for these UAs.
 */

const EXPLICIT_CRAWLER_SUBSTRINGS = [
  'facebookexternalhit',
  'meta-externalagent',
  'facebot',
  'headlesschrome',
] as const;

const GENERAL_CRAWLER_REGEX = /bot|crawler|spider/i;

export function isAnalyticsBotUserAgent(userAgent: string | undefined | null): boolean {
  if (!userAgent || typeof userAgent !== 'string') {
    return false;
  }
  const ua = userAgent.toLowerCase();
  if (EXPLICIT_CRAWLER_SUBSTRINGS.some((s) => ua.includes(s))) {
    return true;
  }
  return GENERAL_CRAWLER_REGEX.test(userAgent);
}

export function isAnalyticsBotEnvironment(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return isAnalyticsBotUserAgent(navigator.userAgent);
}
